<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table :headers="tableHeaders" :items="allowance" :item-key="allowance.id" :loading="loading" hide-actions class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.item.name }}</td>
                                <td class="text-xs-left">{{ props.item.department }}</td>
                                <td class="text-xs-center">{{ props.item.allowance }}</td>
                                <td class="text-xs-center">{{ props.item.remaining }}</td>
                                <td class="text-xs-center">{{ props.item.holidays }}</td>
                                <td class="text-xs-center">{{ props.item.sickDays }}</td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            tableHeaders: [ { text: 'Name', sortable: false },
                            { text: 'Department', sortable: false },
                            { text: 'Allowance', sortable: false, align: 'center' },
                            { text: 'Remaining', sortable: false, align: 'center' },
                            { text: 'Holidays', sortable: false, align: 'center' },
                            { text: 'Sick Days', sortable: false, align: 'center' },
            ],
            allowance: [],
            loading: true
        }
    },
    beforeMount() {
        this.getHolidayAllowances();
    },
    methods: {
        getHolidayAllowances() {
            axios({
            method: 'get',
            url: 'https://controlapi.totalprocessing.com/api/get-holiday-allowances',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.allowance = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
    }
}
</script>

<style>

</style>
